import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useQuery } from '@apollo/client';

import { meQuery } from '@libs/graphql';
import { useApiResponse } from '@libs/hooks';
import { JurisdictionsEnum } from '@libs/backend-common';
import { Typography, CloseIcon } from '@libs/components';

import { bitnetLogoSmall, CrexoneMobileLogo } from 'src/assets';
import { getPlatformUnderConstructionStatusQuery } from 'src/gql';
import { useAppDisclaimer, useJurisdictionDetector } from 'src/hooks';

import {
  BackBtn,
  BitnetLogo,
  CustomImgCont,
  CustomBackBtnImg,
  CustomTransactionsCont,
  CustomTransactionHeader,
  HeaderTitleWrapper,
} from './styles';

export type TransactionsProp = PropsWithChildren & {
  headTitle?: string;
  headTitleLeft?: JSX.Element;
  onClose?: () => void;
  onGoBack?: () => void;
  isBackButtonVisible?: boolean;
};
const TransactionLayout: React.FC<TransactionsProp> = ({
  headTitle,
  headTitleLeft,
  children,
  isBackButtonVisible = true,
  onGoBack,
  onClose,
}) => {
  const navigate = useNavigate();
  const { colors } = useTheme();

  const meRes = useQuery(meQuery);
  const { loading } = useApiResponse(meRes);

  const handleGoBack = () => {
    if (!isBackButtonVisible) return;

    onGoBack?.();
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate('/');
    }
  };
  const { currentJurisdiction } = useJurisdictionDetector();
  const IS_GLOBAL_JURISDICTION = currentJurisdiction === JurisdictionsEnum.UA;

  const res = useQuery(getPlatformUnderConstructionStatusQuery);
  const { response } = useApiResponse(res);

  const isUnderConstruction = response?.getPlatformUnderConstructionStatus;
  const { isAppDisclaimerVisible } = useAppDisclaimer();

  if (loading) return null;

  return (
    <CustomTransactionsCont
      isUnderConstruction={isUnderConstruction}
      isAppDisclaimerVisible={isAppDisclaimerVisible}
    >
      <CustomTransactionHeader>
        <BitnetLogo
          onClick={handleClose}
          src={IS_GLOBAL_JURISDICTION ? CrexoneMobileLogo : bitnetLogoSmall}
          alt="Bitnet"
        />
        <BackBtn hasCursor={isBackButtonVisible} onClick={handleGoBack}>
          {isBackButtonVisible && (
            <CustomBackBtnImg data-testid="transaction-back-btn" />
          )}
        </BackBtn>
        <HeaderTitleWrapper>
          {headTitleLeft}
          <Typography as="h2" type="headline" fontFamily="primaryBold">
            {headTitle}
          </Typography>
        </HeaderTitleWrapper>

        <CustomImgCont onClick={handleClose}>
          <CloseIcon color={colors.text.default} />
        </CustomImgCont>
      </CustomTransactionHeader>
      {children}
    </CustomTransactionsCont>
  );
};
export default TransactionLayout;
